import { Button, Center, Container, Heading, HStack, Input, Stack } from '@chakra-ui/react'
import { RecaptchaVerifier, signInWithPhoneNumber, } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import AppHeader from '../../Components/AppHeader'
import { auth, db } from '../../Config/firebase';
import AuthContext from '../../Routes/hooks/AuthContext';

function LoginPage() {
	const [email, setEmail] = useState()
	const [password, setPassword] = useState()
	const [numberPhone, setNumberPhone] = useState()
	const [expandForm, setExpandForm] = useState(false)
	const [otpCode, setOtpCode] = useState('')

	const {notify}= useContext(AuthContext)
	const countryCode = "+62"

	const navigate = useNavigate()

	const generateRecaptcha = () => {
		window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
			'size': 'invisible',
			'callback': (response) => {
				console.log(response, 'response')
				// reCAPTCHA solved, allow signInWithPhoneNumber.
			}
		}, auth);
	}

	const verifyOtp = () => {
		if (otpCode.length === 6) {
			console.log(otpCode)
			let confirmationResult = window.confirmationResult
			confirmationResult.confirm(otpCode).then(async (result) => {
				const user = result.user;
				console.log(user,'this is the return')

				const docRef = doc(db, "users",user.uid);
				const docSnap = await getDoc(docRef)
					console.log(docSnap.data(),'this is from uid')
					if(!docSnap.exists()){
						await setDoc(doc(db, "users", user.uid), {role:'user'},{ merge: true })
					}
					notify('Login Sukses',`Login sukses dengan OTP ${otpCode}`,'success')
					navigate('/')

				
				
			}).catch((error) => {
				// User couldn't sign in (bad verification code?)
				// ...
				console.log(error, 'error')
				notify('Login gagal',error.message,'error')


			});
		}
	}



	const setUpRecaptcha = () => {

		// get first number & convert with +62
		// const firstDigitNum = Number(numberPhone);
		// if(firstDigitNum===0)
		// const newNumber

		setExpandForm(true)
		generateRecaptcha()
		let appVerifier = window.recaptchaVerifier
		signInWithPhoneNumber(auth, numberPhone, appVerifier)
			.then(confirmationResult => {
				window.confirmationResult = confirmationResult
			})
			.catch(function (error) {
				// Error; SMS not sent
				// ...
				console.log(error)
			});
	}

	return (
		<>

			<Center height='90vh'>
				<Stack>
					<div id="recaptcha-container"></div>
					<Heading>Login / Daftar</Heading>
					<Input type='text' maxW='2xs' placeholder='No HP' width='full' onChange={(e) => setNumberPhone(e.target.value)} />
					<Button colorScheme='teal' id='sign-in-button' onClick={() => setUpRecaptcha()}>Login</Button>
					{expandForm && (
						<Stack>
							<Input type='text' maxW='2xs' placeholder='OTP' width='full' onChange={(e) => setOtpCode(e.target.value)} />
							<Button onClick={() => verifyOtp()}>Verify OTP</Button>
						</Stack>
					)}
					
				</Stack>

			</Center>

		</>
	)
}

export default LoginPage